import * as React from 'react';
import { useScrollTrigger, Slide } from '@material-ui/core';

interface IHideOnScrollProps {

}

const HideOnScroll: React.FunctionComponent<IHideOnScrollProps> = ({
    children
}) => {
    const trigger = useScrollTrigger();

    return (
        <Slide appear={false} direction="down" in={!trigger}>
            {children as any}
        </Slide>
    );
}

export default HideOnScroll;


// WEBPACK FOOTER //
// ./src/components/HideOnScroll.tsx